
import Vue from 'vue'
import { MultiSelect } from '@/components/input'

export default Vue.extend({
   name: 'FilterMultiselect',
   props: {
      title: String,
      initial: { default: () => [] },
      size: { type: String, default: 'btn-sm' },
      nonSelectedText: { type: String, default: 'None selected' },
      allSelectedText: { type: String, default: 'All selected' },
      showSelectAll: { type: Boolean, default: false },
      maxSelections: { type: Number, default: 3 },
      options: { type: Array as () => NameValuePair[], default: () => [] },
   },
   methods: {
      onChange(data: any) {
         this.$emit('input', data)
         this.$emit('change', data)
      },
   },
   components: {
      MultiSelect,
   },
})
